<template lang="pug">
extends ../filter/dynamic-filter-template.pug

block item
    template(#receipts.drawer_session_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}

    template(#receipts.day_operation_id="props")
        div
            span.block {{ props.value.display_name }}
            small.text-muted(v-if="props.value.owner_outlets")
                | {{ props.value.outlet_name }} <br/>
            small.text-muted
                | {{ props.value.staff_name }}
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import dynamicFilterBase from '@js/components/filter/dynamic-filter-base';
import tillFilterMixin from '@js/components/till-filter/till-filter-mixin';
import paymentFilterMixin from '@js/components/payment-filter/payment-filter-mixin';

export default {
    extends: dynamicFilterBase,

    mixins: [tillFilterMixin, paymentFilterMixin],

    props: {
        till_columns: {
            type: Object | Array,
            default: () => null,
        },
    },

    computed: {
        ...mapState('tillFilter', ['filters', 'searchMeta']),
    },

    created() {
        this.getSearchMeta(this.till_columns);
    },

    methods: {
        ...mapActions('tillFilter', ['getSearchMeta']),

        ...mapMutations('tillFilter', ['setFilters']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/till-filter/till-dynamic-filter.vue